// extracted by mini-css-extract-plugin
export var container = "_ja-0";
export var dotAnimation = "_ja-2";
export var dotsLoading = "_ja-1";